require('./img/bg_paper.jpg.webp');
require('./img/bg_tear_down.png.webp');
require('./img/bg_tear_right.png.webp');
require('./img/button-icon.png.webp');
require('./img/marker.png.webp');
require('./img/Samson Druck Logo.png.webp');

require('./img/bg_logo_samson_288.png');
require('./img/bg_logo_samson_288.png.webp');
require('./img/bg_logo_samson_512.png');
require('./img/bg_logo_samson_512.png.webp');
require('./img/bg_logo_samson_614.png');
require('./img/bg_logo_samson_614.png.webp');
require('./img/bg_logo_samson_819.png');
require('./img/bg_logo_samson_819.png.webp');
require('./img/bg_logo_samson_1024.png');
require('./img/bg_logo_samson_1024.png.webp');
